import { render, staticRenderFns } from "./CSinRegistros.vue?vue&type=template&id=11cad3be&"
import script from "./CSinRegistros.vue?vue&type=script&lang=js&"
export * from "./CSinRegistros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports